module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"ru":{"error":"Что-то пошло не так","title":"Парфюмерный термин","read_also":"Читайте также","best_articles":"Лучшие статьи","chained_pages":"Интересные подборки","tooltip_share":"Поделиться","faqTitle":"Что такое {title}?"}}')
  delete Component.options._Ctor
}
